import { Field, useFormikContext } from 'formik';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import { getAllTemplateReportTypeNamesWithPagination } from '../../services/reportService';
import { IAppState } from '../../store/types';
import { requiredValidation } from '../../utilities/Validation';
import { appendFilter } from '../../utilities/filters';
import Description from '../description/Description';
import Label from '../label/label';
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';

export const ReportCard: FC = () => {
    const { translate } = useLocale();
    const { values, errors, setFieldValue } = useFormikContext<any>();
    const user = useSelector((state: IAppState) => (state.userInfo));

    const onSelect = (id, item) => {
        setFieldValue('typeId', item.reportType)
        setFieldValue('reportSubTypeId', item.reportSubType)
        setFieldValue('reportId', id)
    }

    return <>
        <div className="flex flex-row mb-2 mr-6">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='nameLabelId'>
                    <Label
                        htmlFor="name"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                    {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                </div>
                <Field id='nameInputFieldId'
                    type="text"
                    name="name"
                    autoFocus
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                    validate={(value) => requiredValidation(value, translate)} />
            </div>
        </div>
        <div className="flex flex-row mb-2 mr-6">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='reportTypeLabelId'>
                    <Label htmlFor='reportId'
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.type)}:</Label>
                    {errors.reportId ? <span className='text-red-600 text-xs'>{errors.reportId}</span> : null}
                </div>

                <span id='reportTypeId'>
                    {values.id
                        ? <Field
                            value={values.type}
                            disabled={true}
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                        : 
                        <PaginatedSearchableSelectField
                            name={translate.byKey(TranslationKeys.type)}
                            key={"reportIdKey"}
                            accessor='reportId'
                            dataMethod={(listQuery) => getAllTemplateReportTypeNamesWithPagination(
                                {...listQuery, 
                                    filters: appendFilter('TEMPLATE', "Default Reports", "rptSysname", [], "=in=")
                                }, 
                                user.profileId
                            )}
                            searchAccessor={'trnName'}
                            onSelect={(id, item) => onSelect(id, item)}
                            required={true}
                        />
                        }
                </span>
            </div>
        </div>
        <div className="flex flex-row flex-1 pt-3 ">
            <div className="flex flex-col flex-1 pr-3">
                <Description title={translate.byKey(TranslationKeys.notes)} modalDescription={true} />
            </div>
        </div>
    </>
};


